const PERMISSION = {
	TYPE: {
		VIEWER: 1,
		WORKER: 2,
		ADMIN: 4,
	},
	ROLE: {
		VIEWER: 1,
		WORKER: 2,
		ADMIN: 5,
		ADMIN_WORKER: 7,
	},
};
const SLIDE = {
	STATUS: {
		LEFT  : -1,
		CENTER: 0,
		RIGHT : 1,
	},
};
const CALENDAR_TICK = {
	TERM: 1,
	DAY: 2,
	WEEK: 3,
};

const UNIT_WIDTH = {
	TICK: 42,
	TERM: 84,
	DAY: 42,
	WEEK: 6,
};
const FORM_MODE = {
	EDIT: 1,
	REFERENCE: 2,
	ENTRY: 3,
};
const VOID_FLAG = {
	VALID: 0,
	VOID: 1,
};
const DISPLAY_PERIOD = {
	DEFAULT: {
		TERM: 30,
		DAY: 60,
		WEEK: 360,
	},
	EXPAND: {
		TERM: 14,
		DAY: 30,
		WEEK: 240,
	},
	OFFSET: {
		TERM: 14,
		DAY: 30,
		WEEK: 180,
	},
	MARGIN: {
		TERM: 14,
		DAY: 30,
		WEEK: 240,
	},
};

const INTERVAL = {
	PRINT_SCHEDULE: 5000,
	PRINT_SCHEDULE_TIMEOUT: 30000,
};

const FILTERING_STATUS = {
	ALL: 1,
	DONE: 2,
	PROGRESS: 3,
};

const PRINT_SCHEDULE_PERIOD ={
	FUTURE: 5,
	PAST:1,
};

const FETCH_PERIOD_RANGE ={
	YEAR: 3,
};

const IMAGE_MAX_SIZE = {
	ORIGINAL: {
		WIDTH: 0,
		HEIGHT: 0,
		PREFIX: '',
		SUFFIX: '_orig',
	},
	SXGA: {
		WIDTH: 1280,
		HEIGHT: 1280,
		PREFIX: '',
		SUFFIX: '_sxga',
	},
	THUMBNAIL: {
		WIDTH: 340,
		HEIGHT: 340,
		PREFIX: 'thumbnail_',
		SUFFIX: '_thumbnail',
	},
};

const PHOTOALBUM_IMAGE_MAX_COUNT = 999;

const REFERENCE = {
	TRUE: 1,
	FALSE: 0,
};

const DISPLAY_LIST_TYPE = {
	PROJECT: 0,
	MEMBER: 1,
};

const GANTTBOARD_EVENT_ID = {
	DATASET_UPDATE: 1,
	TALKROOM_APPEND_MESSAGE: 2,
	PHOTOALBUM_UPDATE: 3,
	ALBUM_DOWNLOAD: 4,
};

const ARCHIVE_TYPE = {
	PROJECT_ALL: 'project_all',
	SCHEDULE_ALL: 'schedule_all',
	SCHEDULE_SELECTED: 'schedule_selected',
	ALBUM_ALL: 'album_all',
	ALBUM_SELECTED: 'album_selected',
};

const DATETIME_FORMAT = '%Y年%m月%d日 %H:%M';

const COLOR_SELECT_TYPE = {
	SINGLE: 1,
	MULTIPLE: 2,
}

const WEEKS_NAMES = ['日', '月', '火', '水', '木', '金', '土'];

export {
	PERMISSION,
	SLIDE,
	CALENDAR_TICK,
	UNIT_WIDTH,
	FORM_MODE,
	VOID_FLAG,
	DISPLAY_PERIOD,
	INTERVAL,
	FILTERING_STATUS,
	PRINT_SCHEDULE_PERIOD,
	FETCH_PERIOD_RANGE,
	IMAGE_MAX_SIZE,
	PHOTOALBUM_IMAGE_MAX_COUNT,
	REFERENCE,
	DISPLAY_LIST_TYPE,
	GANTTBOARD_EVENT_ID,
	ARCHIVE_TYPE,
	DATETIME_FORMAT,
	COLOR_SELECT_TYPE,
	WEEKS_NAMES,
};
